import { TransformPlainObject } from './transform.plainObject';
import { ExpressionColumnBasePlainObject } from './expressionColumn.plainObject';

export class SchemaModifierBasePlainObject extends TransformPlainObject {
    public columns: ExpressionColumnBasePlainObject[] = [];
}
